import { PDFDocument, PDFName } from 'pdf-lib';

export interface EdxMetadataPayload {
	documentId?: string;
	realmId?: string;
	planHash?: string;
	pageCount?: number;
	crossRefCount?: number;
	numberingSchema?: string;
	astProjection?: unknown;
}

export async function attachEdxMetadata(doc: PDFDocument, payload: EdxMetadataPayload): Promise<void> {
	try {
		const json = JSON.stringify(payload, null, 2);
		// Embed as a simple Metadata string attachment via Names/EmbeddedFiles is non-trivial with pdf-lib types.
		// For v1, store the payload inside the Info dictionary custom key as a JSON string (best-effort, small size only).
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).setTitle?.('EdgeDocs Document');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).setSubject?.('EdgeDocs AI Metadata');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).setProducer?.('EdgeDocs PDF Engine');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).context?.trailerInfo?.set?.(PDFName.of('EDX_CONTEXT'), doc.context.obj(json));
	} catch {
		// best-effort; do not fail PDF creation
	}
}

export interface EdxDocMetadata {
	documentId?: string;
	realmId?: string;
	versionId?: string;
	versionHash?: string;
	planHash?: string;
	pageCount?: number;
	crossRefCount?: number;
	numberingSchema?: string;
	createdAt?: string;
}

export interface EdxAiPayload {
	aiAnnotations?: Array<{ type: string; payload: unknown }>;
	insights?: unknown[];
	classifiers?: unknown[];
	modelInfo?: { provider?: string; model?: string; runId?: string };
}

export async function attachDocMetadata(doc: PDFDocument, payloadOrJson: string | EdxDocMetadata): Promise<void> {
	try {
		const json = typeof payloadOrJson === 'string' ? payloadOrJson : JSON.stringify(payloadOrJson);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).context?.trailerInfo?.set?.(PDFName.of('EDX_DOC'), doc.context.obj(json));
	} catch {}
}

export async function attachAiMetadata(doc: PDFDocument, payloadOrJson: string | EdxAiPayload): Promise<void> {
	try {
		const json = typeof payloadOrJson === 'string' ? payloadOrJson : JSON.stringify(payloadOrJson);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(doc as any).context?.trailerInfo?.set?.(PDFName.of('EDX_AI'), doc.context.obj(json));
	} catch {}
}

export function setPdfAInfo(doc: PDFDocument, info: { title?: string; creator?: string; producer?: string; createdAt?: Date; modifiedAt?: Date }): void {
	try {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const d: any = doc;
		if (info.title && d.setTitle) d.setTitle(info.title);
		if (info.creator && d.setCreator) d.setCreator(info.creator);
		if (info.producer && d.setProducer) d.setProducer(info.producer);
		if (info.createdAt && d.setCreationDate) d.setCreationDate(info.createdAt);
		if (info.modifiedAt && d.setModificationDate) d.setModificationDate(info.modifiedAt);
	} catch {}
}


